var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { width: "95%" } },
    [
      _vm.loading
        ? [_c("Loader", { attrs: { delay: 0 } })]
        : [
            !_vm.showcidi
              ? _c("b-table", {
                  staticClass: "customtable",
                  attrs: {
                    striped: "",
                    hover: "",
                    items: _vm.tableObjects,
                    fields: _vm.fields
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "showCampaign",
                      fn: function(row) {
                        return [
                          _c(
                            "b-button",
                            {
                              staticClass: "mr-2",
                              attrs: { size: "sm", disabled: "" }
                            },
                            [_vm._v("Campaña")]
                          )
                        ]
                      }
                    },
                    {
                      key: "showDetailsCIDI",
                      fn: function(row) {
                        return [
                          _c(
                            "b-button",
                            {
                              staticClass: "mr-2",
                              attrs: { size: "sm" },
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  _vm.getCidi(row.item)
                                }
                              }
                            },
                            [_vm._v("Ver")]
                          )
                        ]
                      }
                    }
                  ])
                })
              : _c(
                  "div",
                  [
                    _c(
                      "b-button",
                      {
                        staticClass: "mr-2",
                        attrs: { size: "sm" },
                        on: {
                          click: function($event) {
                            _vm.showcidi = false
                          }
                        }
                      },
                      [_vm._v("Atrás")]
                    ),
                    _vm._v(" "),
                    _c(
                      "b-card",
                      {
                        staticClass: "text-center mt-1",
                        staticStyle: { "border-color": "#7b7b7b" }
                      },
                      [
                        _c("h2", [_vm._v("Características")]),
                        _vm._v(" "),
                        _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    staticStyle: { "font-size": "1rem" },
                                    attrs: { label: "CIDI" }
                                  },
                                  [
                                    _c("b-form-input", {
                                      attrs: { disabled: "" },
                                      model: {
                                        value: _vm.cididata.supply_id,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.cididata,
                                            "supply_id",
                                            $$v
                                          )
                                        },
                                        expression: "cididata.supply_id"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    staticStyle: { "font-size": "1rem" },
                                    attrs: { label: "ID Suministrado CC" }
                                  },
                                  [
                                    _c("b-form-input", {
                                      attrs: { disabled: "" },
                                      model: {
                                        value: _vm.cididata.supply_cc_id,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.cididata,
                                            "supply_cc_id",
                                            $$v
                                          )
                                        },
                                        expression: "cididata.supply_cc_id"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    staticStyle: { "font-size": "1rem" },
                                    attrs: { label: "Mercado" }
                                  },
                                  [
                                    _vm.cididata.market
                                      ? _c("b-form-input", {
                                          attrs: { disabled: "" },
                                          model: {
                                            value:
                                              _vm.cididata.market.cod_market,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.cididata.market,
                                                "cod_market",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "cididata.market.cod_market"
                                          }
                                        })
                                      : _c("b-form-input", {
                                          attrs: { disabled: "" }
                                        })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    staticStyle: { "font-size": "1rem" },
                                    attrs: { label: "Status" }
                                  },
                                  [
                                    _vm.cididata.cod_supplies_status
                                      ? _c("b-form-input", {
                                          attrs: { disabled: "" },
                                          model: {
                                            value:
                                              _vm.cididata.cod_supplies_status
                                                .status_description,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.cididata
                                                  .cod_supplies_status,
                                                "status_description",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "cididata.cod_supplies_status.status_description"
                                          }
                                        })
                                      : _c("b-form-input", {
                                          attrs: { disabled: "" }
                                        })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    staticStyle: { "font-size": "1rem" },
                                    attrs: { label: "Servicio disponible" }
                                  },
                                  [
                                    _c("b-form-input", {
                                      attrs: { disabled: "" },
                                      model: {
                                        value: _vm.cididata.vailable_services,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.cididata,
                                            "vailable_services",
                                            $$v
                                          )
                                        },
                                        expression: "cididata.vailable_services"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    staticStyle: { "font-size": "1rem" },
                                    attrs: { label: "Caldera centralizada" }
                                  },
                                  [
                                    _vm.cididata.central_boiler
                                      ? _c("b-form-input", {
                                          attrs: { disabled: "" },
                                          model: {
                                            value:
                                              _vm.cididata.central_boiler
                                                .boiler_description,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.cididata.central_boiler,
                                                "boiler_description",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "cididata.central_boiler.boiler_description"
                                          }
                                        })
                                      : _c("b-form-input", {
                                          attrs: { disabled: "" }
                                        })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    staticStyle: { "font-size": "1rem" },
                                    attrs: { label: "Tipo combustible caldera" }
                                  },
                                  [
                                    _vm.cididata.market &&
                                    _vm.cididata.market.combustible_type
                                      ? _c("b-form-input", {
                                          attrs: { disabled: "" },
                                          model: {
                                            value:
                                              _vm.cididata.market
                                                .combustible_type
                                                .combustible_description,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.cididata.market
                                                  .combustible_type,
                                                "combustible_description",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "cididata.market.combustible_type.combustible_description"
                                          }
                                        })
                                      : _c("b-form-input", {
                                          attrs: { disabled: "" }
                                        })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    staticStyle: { "font-size": "1rem" },
                                    attrs: { label: "Tipo uso" }
                                  },
                                  [
                                    _vm.cididata.cod_supplies_status
                                      ? _c("b-form-input", {
                                          attrs: { disabled: "" },
                                          model: {
                                            value:
                                              _vm.cididata.use_type
                                                .use_type_description,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.cididata.use_type,
                                                "use_type_description",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "cididata.use_type.use_type_description"
                                          }
                                        })
                                      : _c("b-form-input", {
                                          attrs: { disabled: "" }
                                        })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-card",
                      {
                        staticClass: "text-center mt-4",
                        staticStyle: { "border-color": "#7b7b7b" }
                      },
                      [
                        _c("h2", [_vm._v("Localización")]),
                        _vm._v(" "),
                        _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    staticStyle: { "font-size": "1rem" },
                                    attrs: { label: "Bloque" }
                                  },
                                  [
                                    _c("b-form-input", {
                                      attrs: { disabled: "" },
                                      model: {
                                        value: _vm.cididata.block,
                                        callback: function($$v) {
                                          _vm.$set(_vm.cididata, "block", $$v)
                                        },
                                        expression: "cididata.block"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    staticStyle: { "font-size": "1rem" },
                                    attrs: { label: "Escalera" }
                                  },
                                  [
                                    _c("b-form-input", {
                                      attrs: { disabled: "" },
                                      model: {
                                        value: _vm.cididata.stair,
                                        callback: function($$v) {
                                          _vm.$set(_vm.cididata, "stair", $$v)
                                        },
                                        expression: "cididata.stair"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    staticStyle: { "font-size": "1rem" },
                                    attrs: { label: "Planta" }
                                  },
                                  [
                                    _c("b-form-input", {
                                      attrs: { disabled: "" },
                                      model: {
                                        value: _vm.cididata.floor,
                                        callback: function($$v) {
                                          _vm.$set(_vm.cididata, "floor", $$v)
                                        },
                                        expression: "cididata.floor"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    staticStyle: { "font-size": "1rem" },
                                    attrs: { label: "Puerta" }
                                  },
                                  [
                                    _c("b-form-input", {
                                      attrs: { disabled: "" },
                                      model: {
                                        value: _vm.cididata.door,
                                        callback: function($$v) {
                                          _vm.$set(_vm.cididata, "door", $$v)
                                        },
                                        expression: "cididata.door"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    staticStyle: { "font-size": "1rem" },
                                    attrs: { label: "Resto dirección" }
                                  },
                                  [
                                    _c("b-form-input", {
                                      attrs: { disabled: "" },
                                      model: {
                                        value: _vm.cididata.rest_address,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.cididata,
                                            "rest_address",
                                            $$v
                                          )
                                        },
                                        expression: "cididata.rest_address"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-card",
                      {
                        staticClass: "text-center mt-4",
                        staticStyle: { "border-color": "#7b7b7b" }
                      },
                      [
                        _c("h2", [_vm._v("Catastro")]),
                        _vm._v(" "),
                        _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    staticStyle: { "font-size": "1rem" },
                                    attrs: { label: "Referencia Catastral" }
                                  },
                                  [
                                    _c("b-form-input", {
                                      attrs: { disabled: "" },
                                      model: {
                                        value:
                                          _vm.cididata.referencia_catastral,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.cididata,
                                            "referencia_catastral",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "cididata.referencia_catastral"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-card",
                      {
                        staticClass: "text-center mt-4",
                        staticStyle: { "border-color": "#7b7b7b" }
                      },
                      [
                        _c("h2", [_vm._v("Servicio")]),
                        _vm._v(" "),
                        _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    staticStyle: { "font-size": "1rem" },
                                    attrs: {
                                      label: "Última puesta en servicio"
                                    }
                                  },
                                  [
                                    _c("b-form-input", {
                                      attrs: { disabled: "" },
                                      model: {
                                        value:
                                          _vm.cididata.last_date_starting_up,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.cididata,
                                            "last_date_starting_up",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "cididata.last_date_starting_up"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    staticStyle: { "font-size": "1rem" },
                                    attrs: { label: "Último cese" }
                                  },
                                  [
                                    _c("b-form-input", {
                                      attrs: { disabled: "" },
                                      model: {
                                        value:
                                          _vm.cididata.last_date_suspension,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.cididata,
                                            "last_date_suspension",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "cididata.last_date_suspension"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    staticStyle: { "font-size": "1rem" },
                                    attrs: {
                                      label: "Primera puesta en servicio"
                                    }
                                  },
                                  [
                                    _c("b-form-input", {
                                      attrs: { disabled: "" },
                                      model: {
                                        value:
                                          _vm.cididata.first_date_starting_up,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.cididata,
                                            "first_date_starting_up",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "cididata.first_date_starting_up"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    staticStyle: { "font-size": "1rem" },
                                    attrs: { label: "Resto dirección" }
                                  },
                                  [
                                    _c("b-form-input", {
                                      attrs: { disabled: "" },
                                      model: {
                                        value: _vm.cididata.rest_address,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.cididata,
                                            "rest_address",
                                            $$v
                                          )
                                        },
                                        expression: "cididata.rest_address"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-card",
                      {
                        staticClass: "text-center mt-4",
                        staticStyle: { "border-color": "#7b7b7b" }
                      },
                      [
                        _c("h2", [_vm._v("Derivación")]),
                        _vm._v(" "),
                        _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    staticStyle: { "font-size": "1rem" },
                                    attrs: { label: "Estado" }
                                  },
                                  [
                                    _vm.cididata.derivation_status
                                      ? _c("b-form-input", {
                                          attrs: { disabled: "" },
                                          model: {
                                            value:
                                              _vm.cididata.derivation_status
                                                .description,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.cididata.derivation_status,
                                                "description",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "cididata.derivation_status.description"
                                          }
                                        })
                                      : _c("b-form-input", {
                                          attrs: { disabled: "" }
                                        })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    staticStyle: { "font-size": "1rem" },
                                    attrs: { label: "Propiedad" }
                                  },
                                  [
                                    _vm.cididata.derivation_property_type
                                      ? _c("b-form-input", {
                                          attrs: { disabled: "" },
                                          model: {
                                            value:
                                              _vm.cididata
                                                .derivation_property_type
                                                .description,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.cididata
                                                  .derivation_property_type,
                                                "description",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "cididata.derivation_property_type.description"
                                          }
                                        })
                                      : _c("b-form-input", {
                                          attrs: { disabled: "" }
                                        })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    staticStyle: { "font-size": "1rem" },
                                    attrs: {
                                      label: "Primera puesta en servicio"
                                    }
                                  },
                                  [
                                    _c("b-form-input", {
                                      attrs: { disabled: "" },
                                      model: {
                                        value:
                                          _vm.cididata
                                            .starting_up_first_date_derivation,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.cididata,
                                            "starting_up_first_date_derivation",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "cididata.starting_up_first_date_derivation"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    staticStyle: { "font-size": "1rem" },
                                    attrs: { label: "Primera captación" }
                                  },
                                  [
                                    _c("b-form-input", {
                                      attrs: { disabled: "" },
                                      model: {
                                        value:
                                          _vm.cididata
                                            .first_captation_date_derivation,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.cididata,
                                            "first_captation_date_derivation",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "cididata.first_captation_date_derivation"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-card",
                      {
                        staticClass: "text-center mt-4",
                        staticStyle: { "border-color": "#7b7b7b" }
                      },
                      [
                        _c("h2", [_vm._v("IRC")]),
                        _vm._v(" "),
                        _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    staticStyle: { "font-size": "1rem" },
                                    attrs: { label: "Estado" }
                                  },
                                  [
                                    _vm.cididata.irc_status
                                      ? _c("b-form-input", {
                                          attrs: { disabled: "" },
                                          model: {
                                            value:
                                              _vm.cididata.irc_status
                                                .description,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.cididata.irc_status,
                                                "description",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "cididata.irc_status.description"
                                          }
                                        })
                                      : _c("b-form-input", {
                                          attrs: { disabled: "" }
                                        })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    staticStyle: { "font-size": "1rem" },
                                    attrs: { label: "Propiedad" }
                                  },
                                  [
                                    _vm.cididata.irc_property_type
                                      ? _c("b-form-input", {
                                          attrs: { disabled: "" },
                                          model: {
                                            value:
                                              _vm.cididata.irc_property_type
                                                .description,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.cididata.irc_property_type,
                                                "description",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "cididata.irc_property_type.description"
                                          }
                                        })
                                      : _c("b-form-input", {
                                          attrs: { disabled: "" }
                                        })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    staticStyle: { "font-size": "1rem" },
                                    attrs: { label: "Tipo gas" }
                                  },
                                  [
                                    _vm.cididata.gas_type
                                      ? _c("b-form-input", {
                                          attrs: { disabled: "" },
                                          model: {
                                            value:
                                              _vm.cididata.gas_type.description,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.cididata.gas_type,
                                                "description",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "cididata.gas_type.description"
                                          }
                                        })
                                      : _c("b-form-input", {
                                          attrs: { disabled: "" }
                                        })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-button",
                      {
                        staticClass: "mr-2",
                        attrs: { size: "sm" },
                        on: {
                          click: function($event) {
                            _vm.showcidi = false
                          }
                        }
                      },
                      [_vm._v("Atrás")]
                    )
                  ],
                  1
                )
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Modules/Map/DetailsResidencial/Infoadicional.vue?vue&type=template&id=478cb0d2&
// module id = null
// module chunks = 